/**
 * Contact Form 7 Controller
 * Handles real-time validation, AJAX events, and UI state
 */

const STORAGE_KEY = "contactFormSave";
const successOverlay = document.getElementById("success-overlay");
const successCloseX = document.getElementById("success-close-x");
const submitBtn = document.getElementById("submit-btn");
const statusMessage = document.getElementById("form-status-message");

const inputs = {
  name: {
    el: document.getElementById("name"),
    groupEl: document.getElementById("group-name"),
    validate: (val) => val.trim().length >= 3,
  },
  email: {
    el: document.getElementById("email"),
    groupEl: document.getElementById("group-email"),
    validate: (val) =>
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(val),
  },
  message: {
    el: document.getElementById("message"),
    groupEl: document.getElementById("group-message"),
    validate: (val) => val.trim().length >= 10,
  },
};

let formState = { name: false, email: false, message: false };
let overlayTimeout = null;

/**
 * Core validation logic for individual fields
 * Forces class removal before re-adding to trigger CSS animations properly
 */
function handleValidation(key, value) {
  const { groupEl, el, validate } = inputs[key];
  const val = value.trim();

  // 1. Reset everything to neutral state first
  groupEl.classList.remove("c-form__group--valid", "c-form__group--invalid");
  el.removeAttribute("aria-invalid");

  // 2. If empty, stop here
  if (val === "") {
    formState[key] = false;
    return;
  }

  // 3. Perform validation
  const isValid = validate(val);
  formState[key] = isValid;

  // 4. Force a tiny reflow (optional but helps with buggy CSS animations)
  // void groupEl.offsetWidth;

  // 5. Apply the correct state
  if (isValid) {
    groupEl.classList.add("c-form__group--valid");
    el.setAttribute("aria-invalid", "false");
  } else {
    groupEl.classList.add("c-form__group--invalid");
    el.setAttribute("aria-invalid", "true");
  }
}

/**
 * Updates Submit Button and Status Message visibility
 */
function checkFormValidity() {
  const isFormValid = Object.values(formState).every((state) => state === true);
  if (submitBtn) {
    submitBtn.disabled = !isFormValid;
    statusMessage?.classList.toggle(
      "c-form__status-message--hidden",
      isFormValid,
    );
  }
}

/**
 * Success Overlay Management
 */
function toggleOverlay(show = true) {
  if (show) {
    successOverlay?.classList.add("c-success-overlay--active");
    successOverlay?.setAttribute("aria-hidden", "false");
    successCloseX?.focus();
    overlayTimeout = setTimeout(() => toggleOverlay(false), 5000);
  } else {
    successOverlay?.classList.remove("c-success-overlay--active");
    successOverlay?.setAttribute("aria-hidden", "true");
    if (overlayTimeout) clearTimeout(overlayTimeout);
  }
}

/**
 * Initialize Contact Form 7 lifecycle and validation
 * Targets .c-form__actions for stable loading state management
 */
function initContactForm() {
  const cf7Form = document.querySelector(".wpcf7-form");
  const formActions = document.querySelector(".c-form__actions");

  if (!cf7Form) return;

  // 1. Attach listeners to validation fields
  Object.keys(inputs).forEach((key) => {
    const field = inputs[key];
    if (!field.el) return;

    const updateHandler = (e) => {
      handleValidation(key, e.target.value);
      checkFormValidity();
    };

    field.el.addEventListener("input", debounce(updateHandler, 300));
    field.el.addEventListener("blur", updateHandler);
  });

  // 2. CF7 Lifecycle: Start Loading
  cf7Form.addEventListener("wpcf7beforesubmit", () => {
    formActions?.classList.add("c-form__actions--loading");
    if (submitBtn) submitBtn.disabled = true;
  });

  // 3. CF7 Lifecycle: Global cleanup (triggered on success or failure)
  cf7Form.addEventListener("wpcf7submit", () => {
    formActions?.classList.remove("c-form__actions--loading");
  });

  // 4. CF7 Lifecycle: Success handling
  cf7Form.addEventListener("wpcf7mailsent", () => {
    toggleOverlay(true);
    cf7Form.reset();

    // Reset visual validation states
    Object.keys(inputs).forEach((key) => {
      inputs[key].groupEl?.classList.remove(
        "c-form__group--valid",
        "c-form__group--invalid",
      );
      formState[key] = false;
    });

    checkFormValidity();
  });

  // 5. Success overlay close event
  successCloseX?.addEventListener("click", () => toggleOverlay(false));
}

function debounce(func, delay) {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
}

document.addEventListener("DOMContentLoaded", initContactForm);
